import { Fragment, useEffect, useRef, createRef } from "react";
import { Disclosure } from "@headlessui/react";
import { ChevronUpIcon } from "@heroicons/react/20/solid";
import { Switch } from "@headlessui/react";
//
function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const GridInventarioStockSede = ({ filteredData = [], handleGridInput, handleChangeTextbox, textHabilitados }) => {
  return (
    
            <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8 bg-secundarioMira rounded-sm shadow-sm ">
              <table className="min-w-full divide-y divide-grisMira p-5  shadow-sm shadow-grisMira">
                
                <thead className="sticky top-0 z-10 bg-secundarioMira ">
                  <tr className="w-full divide-x divide-grisMira ">
                    <th
                      scope="col"
                      className=" text-sm font-semibold text-grisMira shadow-sm shadow-grisMira py-3.5 pl-4 pr-3 "
                    >
                      ID PRODUCTO
                    </th>
                    <th
                      scope="col"
                      className=" text-sm font-semibold text-grisMira shadow-sm shadow-grisMira"
                    >
                      CANTIDAD
                    </th>
                    
                    <th
                      scope="col"
                      className=" text-sm font-semibold text-grisMira shadow-sm shadow-grisMira"
                    >
                      EQUIPO
                    </th>
                    <th
                      scope="col"
                      className=" text-sm font-semibold text-grisMira shadow-sm shadow-grisMira"
                    >
                      SEDE
                    </th>
                    
                    
                  </tr>
                </thead>
                

                <tbody className="divide-y divide-grisMira bg-primarioMira w-full">
                  {filteredData?.map((element, index) => (
                        <tr
                          key={index}
                          className={"divide-x divide-grisMira"}
                          >
                          <td className=" whitespace-nowrap p-4 text-sm text-white text-center">
                              <p className={"m-auto"}>{element.IdProducto}</p>  
                          </td>
                          <td className=" whitespace-nowrap p-4 text-sm text-white ">
                            {element.Cantidad}
                          </td>
                          
                          <td className="  whitespace-nowrap p-4 text-sm text-white  text-center">
                            {element.Equipo}
                          </td>
                          
                          <td className=" whitespace-nowrap p-4 text-sm text-white ">
                            {element.Sede}
                          </td>
                        </tr>
                  ))}
                </tbody>
              </table>
            </div>
        
  );
};

export default GridInventarioStockSede;